import { useContext } from "react";
import { UserContext } from "../../../engine/context/User.context";
import { roles } from "../../../utils/constants";
import dayjs from "../../../utils/dayjs";
import { t } from "i18next";

export const miutesMaximumDefault = 361;
let minutesDuration = miutesMaximumDefault * 60;

export const validateTimeBetween = (
  refValidator,
  startKey,
  endKey,
  user,
  isLongDuration = false,
  errorNextDay = true,
) => {
  console.log("validateTimeBetween", refValidator, startKey, endKey, isLongDuration);
  let restricted = true;
  let semiRestricted = true;

  if (user.subRoles.includes(roles.superAdmin)) {
    restricted = false;
  }

  if ([roles.admin, roles.permanance].includes(user.role)) {
    semiRestricted = false;
  }

  let values = refValidator.getFieldsValue(true);
  let start = values[startKey];
  let end = values[endKey];

  if (start === undefined || end === undefined) {
    return Promise.reject(new Error(t("prestations.errorEmpty")));
  }

  // Calculate the total duration in seconds
  const durationSeconds = end.diff(start, "second");

  if (durationSeconds < 0) {
    return Promise.reject(new Error(t("prestations.errorNegative")));
  }

  if (restricted) {
    if (start.isBefore(dayjs()) && errorNextDay && semiRestricted) {
      return Promise.reject(new Error(t("prestations.errorPastTime")));
    }

    if (isLongDuration) {
      minutesDuration = 28800;
    }

    if (durationSeconds >= minutesDuration) {
      return Promise.reject(new Error(t("prestations.errorDuration")));
    }
  }

  return Promise.resolve();
};

export const disabledDatePast = current => {
  return current && current < dayjs().startOf("day");
};

export const disabledDateNext12Months = current => {
  // Rule: Disable dates more than 12 months in the future
  return (
    current &&
    current >
      dayjs()
        .add(12, "month")
        .endOf("day")
  );
};
